shvenergy.icons = (function ($) {
	var svgs;
	var svgCache;
	var iconsLoaded = false;
    var cdnvalue = $("#cdnInput").data("value");
	function init() {
		$.ajax({
            url: "" + cdnvalue + "/dist/svgsprite/icons.svg"

		}).done(function (data) {
			svgCache = data;
			svgs = makeSvgArray(data);
			iconsLoaded = true;
		});
	}

	function makeSvgArray(data) {
		var array = [];
		var icons = data.getElementsByTagName('symbol');
		for (var i = 0; i <= icons.length - 1; i++) {
			array.push(icons[i].getAttribute('id'));
		}
		return array;
	}

	function getSvgArrayFiltered(string) {

		if (!iconsLoaded) {
			console.warn("You need to run 'shvenergy.icons.init()' first");
			return false;
		}

		var array = [];
		for (var i = 0; i <= svgs.length - 1; i++) {
			var name = svgs[i].toLowerCase();
			if (name.indexOf(string.toLowerCase()) !== -1) {
				array.push(svgs[i]);
			}
		}
		return array;

	}

	function getSvgArray() {

		if (!iconsLoaded) {
			console.warn("You need to run 'shvenergy.icons.init()' first");
			return false;
		}

		return svgs;
	}

	function buildIconsView(containerSelector, filter) {

		if (!iconsLoaded) {
			console.warn("You need to run 'shvenergy.icons.init()' first");
			return false;
		}

		var container = containerSelector || "body";
		var iconsWrap = $("<div class='iconswrap' style='display:flex;flex-wrap:wrap;background:#fff; position: fixed; bottom:0; left:0;z-index: 100000;'>");
		var iconsArray = filter ? getSvgArrayFiltered(filter) : getSvgArray();

		for (var i = 0; i < iconsArray.length; i++) {
			var iconSVG = $('<div style="display: flex; flex-direction:column; align-items: center; padding:1em; font-size:10px; border: 1px solid #000; text-align: center;">' +
                '<svg style="margin-bottom: 10px;"><use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#' + iconsArray[i] + '"></use></svg>' +
				'<p style="margin-top: auto;margin-bottom:0; font-family: sans-serif;">' + iconsArray[i] + '</p>' +
				'</div>');
			iconsWrap.append(iconSVG);
		}
		$(container).append(iconsWrap);
		return "succes!";
	}

	return {
		init: init,
		getSvgArray: getSvgArray,
		getSvgArrayFiltered: getSvgArrayFiltered,
		buildIconsView: buildIconsView
	};

})(jQuery);

